
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { DashboardStats } from '@/types/dashboard';

export const useDashboardStats = (locationId?: string) => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchStats();
  }, [locationId]);

  const fetchStats = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // For now, use mock data since the database function doesn't exist yet
      const mockStats: DashboardStats = {
        revenue: 4390,
        appointments_total: 9,
        appointments_completed: 7,
        appointments_no_show: 1,
        credits_redeemed: 2450,
        new_members: 3
      };

      setStats(mockStats);
    } catch (err) {
      console.error('Error fetching dashboard stats:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch stats');
    } finally {
      setIsLoading(false);
    }
  };

  return { stats, isLoading, error, refetch: fetchStats };
};
